// Curated case-study jobs. Swap `hero` / `gallery` URLs for real photos when Paul supplies them.
// Brand info kept minimal (name + color code + hex) so it's easy to update.

export const JOBS = [
    {
        slug: "cabinets-boca",
        title: "Cabinet Refinish — Boca Highlands",
        service: "Cabinet Refinishing",
        location: "Boca Raton, FL",
        duration: "5 days",
        year: "2025",
        hero: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1800&q=80",
        gallery: [
            "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1400&q=80",
            "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80",
            "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1400&q=80",
        ],
        story:
            "Original 90s oak cabinetry pulled, sanded, degreased and sprayed off-site in Paul's booth. Doors returned on the sixth morning with a factory-grade lacquer finish that will not chip when the kids slam it shut.",
        highlights: [
            "Full degreaser + bond primer",
            "HVLP sprayed lacquer, 3 coats",
            "New soft-close hardware",
            "Zero brush marks — spray only",
        ],
        colors: [
            {
                brand: "Benjamin Moore",
                name: "White Dove",
                code: "OC-17",
                hex: "#F0EEE4",
                use: "Uppers",
            },
            {
                brand: "Sherwin-Williams",
                name: "Iron Ore",
                code: "SW 7069",
                hex: "#443F3D",
                use: "Island",
            },
            {
                brand: "Benjamin Moore",
                name: "Simply White",
                code: "OC-117",
                hex: "#F4F1E7",
                use: "Trim",
            },
        ],
    },
    {
        slug: "exterior-delray",
        title: "Two-Story Exterior — Delray Ocean Ridge",
        service: "Exterior Painting",
        location: "Delray Beach, FL",
        duration: "4 days",
        year: "2025",
        hero: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1800&q=80",
        gallery: [
            "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1400&q=80",
            "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1400&q=80",
        ],
        story:
            "Salt-air punished stucco on a two-story oceanfront home. Full pressure wash, elastomeric patch on hairline cracks, then two coats of a marine-grade exterior. Trim knocked out with hand-brush precision under the eaves.",
        highlights: [
            "3,500 PSI pressure wash",
            "Elastomeric crack repair",
            "2 coats — marine-grade",
            "HOA-approved palette",
        ],
        colors: [
            {
                brand: "Sherwin-Williams",
                name: "Alabaster",
                code: "SW 7008",
                hex: "#EDE7DA",
                use: "Body",
            },
            {
                brand: "Behr",
                name: "Cracked Pepper",
                code: "PPU18-01",
                hex: "#3A3A3A",
                use: "Shutters",
            },
            {
                brand: "PPG",
                name: "Delightful Moon",
                code: "1005-1",
                hex: "#F1EFE8",
                use: "Trim",
            },
        ],
    },
    {
        slug: "kids-room-jupiter",
        title: "Kid's Bedroom Feature Wall — Jupiter",
        service: "Interior Painting",
        location: "Jupiter, FL",
        duration: "2 days",
        year: "2025",
        hero: "https://images.unsplash.com/photo-1558442074-3c19857bc1dc?auto=format&fit=crop&w=1800&q=80",
        gallery: [
            "https://images.unsplash.com/photo-1558442074-3c19857bc1dc?auto=format&fit=crop&w=1400&q=80",
            "https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?auto=format&fit=crop&w=1400&q=80",
        ],
        story:
            "Mom asked for 'happy but not overwhelming.' We landed on a soft blush accent wall with crisp cloud-white body. Every edge cut freehand — no tape lines under the crown molding.",
        highlights: [
            "Freehand edge cuts",
            "Low-VOC — kid-safe",
            "Ceiling roll included",
            "Furniture moved & re-set",
        ],
        colors: [
            {
                brand: "Benjamin Moore",
                name: "First Light",
                code: "2102-70",
                hex: "#EBD8D5",
                use: "Feature wall",
            },
            {
                brand: "Benjamin Moore",
                name: "Chantilly Lace",
                code: "OC-65",
                hex: "#F4F4EE",
                use: "Ceiling + trim",
            },
        ],
    },
    {
        slug: "pressure-wash-wellington",
        title: "Full-Property Pressure Wash — Wellington Estate",
        service: "Pressure Washing",
        location: "Wellington, FL",
        duration: "1 day",
        year: "2025",
        hero: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=1800&q=80",
        gallery: [
            "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=1400&q=80",
            "https://images.unsplash.com/photo-1584622781564-1d987f7333c1?auto=format&fit=crop&w=1400&q=80",
        ],
        story:
            "Barrel-tile roof, paver driveway, pool deck and screened enclosure — all softened, treated with a mildewcide, then rinsed to a factory finish. No etching, no plant damage.",
        highlights: [
            "Soft-wash roof method",
            "Mildewcide + brightener",
            "Paver re-sanded post-wash",
            "Plants tarped & rinsed",
        ],
        colors: [],
    },
    {
        slug: "office-repaint-palmbeach",
        title: "Commercial Repaint — Palm Beach Office Suite",
        service: "Commercial Painting",
        location: "Palm Beach, FL",
        duration: "3 nights",
        year: "2025",
        hero: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1800&q=80",
        gallery: [
            "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=80",
            "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1400&q=80",
        ],
        story:
            "4,200 sq ft law-office suite refreshed on nights and weekends so the firm never lost a business hour. Deep charcoal accent walls with warm-white body — the partners have already sent us to two friends.",
        highlights: [
            "After-hours only",
            "Low-odour formulation",
            "Furniture wrapped nightly",
            "Zero business-day downtime",
        ],
        colors: [
            {
                brand: "Sherwin-Williams",
                name: "Peppercorn",
                code: "SW 7674",
                hex: "#57534E",
                use: "Accent",
            },
            {
                brand: "Sherwin-Williams",
                name: "Pure White",
                code: "SW 7005",
                hex: "#EDECE6",
                use: "Body",
            },
            {
                brand: "PPG",
                name: "Black Magic",
                code: "PPG1001-7",
                hex: "#28272C",
                use: "Doors",
            },
        ],
    },
    {
        slug: "wallpaper-removal-boynton",
        title: "Wallpaper Removal + Drywall Repair — Boynton",
        service: "Wallpaper Removal",
        location: "Boynton Beach, FL",
        duration: "3 days",
        year: "2025",
        hero: "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?auto=format&fit=crop&w=1800&q=80",
        gallery: [
            "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?auto=format&fit=crop&w=1400&q=80",
            "https://images.unsplash.com/photo-1519710164239-da123dc03ef4?auto=format&fit=crop&w=1400&q=80",
        ],
        story:
            "1980s vinyl wallpaper across a whole dining room, glued directly to drywall paper. Steam-lifted, sanded, skim-coated, primed with a bonding primer, then two coats of a warm neutral.",
        highlights: [
            "Steam removal — zero gouges",
            "Full skim-coat re-finish",
            "Bond primer applied",
            "Two-coat top color",
        ],
        colors: [
            {
                brand: "Benjamin Moore",
                name: "Edgecomb Gray",
                code: "HC-173",
                hex: "#D6CDBD",
                use: "Walls",
            },
            {
                brand: "Behr",
                name: "Ultra Pure White",
                code: "1850",
                hex: "#F4F1EA",
                use: "Trim",
            },
        ],
    },
];

// Small SVG-esque brand tag map — each returns a text/logo mark to render inline.
// Kept simple (word-marks) so we avoid loading external brand asset dependencies.
export const BRANDS = {
    "Sherwin-Williams": { short: "SW", accent: "#0033A0" },
    "Benjamin Moore":   { short: "BM", accent: "#B41F31" },
    "Behr":             { short: "BEHR", accent: "#F58220" },
    "PPG":              { short: "PPG", accent: "#004E9C" },
};

export function getJob(slug) {
    return JOBS.find((j) => j.slug === slug);
}
